/**
 * Routes and capability slugs only — nothing else.
 *
 * A separate module because `router/workspaces.ts` is imported **eagerly** by the router (it
 * builds `workspaceRoutes`), so anything it imports lands in the application entry. Pulling in
 * the whole of `constants.ts` for two strings would put the metric hints, the range presets and
 * the export vocabulary on the critical path of every first load, marketplace included.
 */
import type { AnalyticsWorkspace } from './types'

export const ROUTES = {
  affiliate: '/app/affiliate/analytics',
  landlord: '/app/landlord/analytics',
  admin: '/app/admin/analytics',
  notifications: (workspace: AnalyticsWorkspace | string) => `/app/${workspace}/notifications`,
} as const

export const CAPABILITIES = {
  affiliateAnalytics: 'affiliate.analytics.view',
  landlordAnalytics: 'landlord.analytics.view',
  adminAccess: 'admin.access',
} as const
